/**
 * The shop's money rules, written once (audit, 1 Oct 2026).
 *
 * They were typed out separately in the cart, the buy block and the shop quiz,
 * so changing free delivery meant finding every copy, and missing one made the
 * cart promise something the server would not charge. The server decides the
 * real figures (OrderService.java: DELIVERY_FEE, FREE_DELIVERY_FROM,
 * SUBSCRIPTION_DISCOUNT); ShopRulesMatchFrontendTest in the backend reads this
 * file and fails the build if the two ever disagree.
 */
export const SHOP_RULES = {
  /** Flat delivery anywhere in Lebanon, in dollars. */
  deliveryFee: 4,
  /** Goods total (before any welcome discount) from which delivery is free. */
  freeDeliveryFrom: 50,
  /** What subscribing takes off every delivery, in percent. */
  subscribeDiscountPercent: 10,
  /** Days from order to the door (owner, 15 Oct 2026). Shown by Google under a product. */
  deliveryDaysMin: 3,
  deliveryDaysMax: 5,
  /**
   * Returns: only a tin damaged on delivery, reported within 48 hours of it
   * arriving, and we put it right rather than refund (owner, 15 Oct 2026).
   */
  damagedReportDays: 2,
} as const;
